import SplashScreen from "./splash.container";

export default SplashScreen;
